
import { Component, Vue, Prop } from "nuxt-property-decorator";
import { Document } from "@/types/responses/inserzione/ResponseInserzioneInterface";

@Component
export default class TheDocuments extends Vue {
  @Prop() doc!: Document;
  @Prop({ default: true }) titleFullLength: boolean;
}
